import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	changeFormToInternalModalTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-title',
		defaultMessage: 'Make form internal only and hide from customer',
		description:
			'The title of the modal asking the user to confirm if they want make the form internal.',
	},
	changeFormToInternalModalBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-body',
		defaultMessage:
			'Any forms made internal will only be seen by agents and hidden in the portal from customers.',
		description:
			'The body content of the modal asking the user to confirm if they want make the form internal.',
	},
	changeFormToInternalModalConfirm: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-confirm',
		defaultMessage: 'Make internal',
		description:
			'The text in the confirmation button of the modal asking the user to confirm if they want to make the form internal.',
	},
	changeFormToInternalModalClose: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-internal-modal-close',
		defaultMessage: 'Cancel',
		description:
			'The label for the close button of the modal asking the user to confirm if they want to make the form internal.',
	},
	changeFormToExternalModalTitle: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-title',
		defaultMessage: 'Make form external and show to customer',
		description:
			'The title of the modal asking the user to confirm if they want make the form external.',
	},
	changeFormToExternalModalBody: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-body',
		defaultMessage:
			'Customers will be able to view this form in the portal and it will no longer be internal only.',
		description:
			'The body content of the modal asking the user to confirm if they want make the form external.',
	},
	changeFormToExternalModalConfirm: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-confirm',
		defaultMessage: 'Make external',
		description:
			'The text in the confirmation button of the modal asking the user to confirm if they want to make the form external.',
	},
	changeFormToExternalModalClose: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-form-to-external-modal-close',
		defaultMessage: 'Cancel',
		description:
			'The label for the close button of the modal asking the user to confirm if they want to make the form external.',
	},
	changeRestrictedFormToExternalWarning: {
		id: 'proforma-panel-in-issue-view-ui.controllers.use-handle-update-form-visibility.change-restricted-form-to-external-warning',
		defaultMessage:
			'Customers may not have access to view this form as it is restricted to certain people. <link>Read more about restricting forms</link>',
		description:
			'The warning message displayed in the modal asking the user to confirm if they want to make a restricted form external.',
	},
});
